import { render } from "./EventRecap.vue?vue&type=template&id=67117ac7"
import script from "./EventRecap.vue?vue&type=script&lang=js"
export * from "./EventRecap.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__